import { render, staticRenderFns } from "./getTimedVibration.vue?vue&type=template&id=bbc8b52e&scoped=true&"
import script from "./getTimedVibration.vue?vue&type=script&lang=js&"
export * from "./getTimedVibration.vue?vue&type=script&lang=js&"
import style0 from "./getTimedVibration.vue?vue&type=style&index=0&id=bbc8b52e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc8b52e",
  null
  
)

export default component.exports